export default "__VITE_ASSET__BFmlKBJL__"